import { useContext } from 'react';

export default function useGetContext(reactContext: any) {
    const context = useContext(reactContext);

    if (!context) return {};

    return context;
}
